<template>
	<div class="inbox__wrap"
        :data-component-name="$options.name"
	>
		<div class="c-inbox-header">
			<div class="c-inbox-header__content">
				<!-- <div class="o-row -userProfile-row"
					v-if="initialTab=='pendings' && (myUserProfile.role=='ADMINISTRATOR' || myUserProfile.role=='MANAGER')"
				>
					<div class="o-col -toggle -select__wrap o-userProfile-select" v-if="!isMobile">
						<UserProfileInput
							dark
                            :rounded="true"
                            :standout="true"
                            :outlined="false"
                            :filled="false"
                            :dense="true"
                            :multiple="false"
                            v-model="userProfile"
                            label="Utilisateur"
                            @input="$emit('change-inbox', $event)"
                            :clearable="false"
                            :hide-selected="true"
                            :fill-input="true"
						/>
					</div>
					<div class="o-col -middle o-userProfile-select" v-else>
						<UserProfileInput
                            :rounded="true"
                            :standout="true"
                            :outlined="false"
                            :filled="false"
                            :dense="true"
                            :multiple="false"
                            v-model="userProfile"
                            label="Utilisateur"
                            @input="$emit('change-inbox', $event)"
                            :clearable="false"
                            :hide-selected="true"
                            :fill-input="true"
                            class="-o-userProfile-input"
						/>
					</div>
				</div> -->
				<div class="o-row -hidden-mobile" v-if="initialTab=='inbox' || initialTab=='sent'">
					<div class="o-col -middle o-userProfile-select" v-if="initialTab=='inbox'">
						<h1>Boîte de réception</h1>
					</div>
					<!-- <div class="o-col -middle o-userProfile-select" v-else>
						<h1>Éléments envoyés</h1>
					</div> -->
				</div>
				<div class="c-inbox-header-unread o-row -nowrap" v-if="(initialTab=='inbox' || initialTab=='sent') && pendingAssignmentsCount>0">
					<div class="o-col flex-grow -middle">
						<div class="-title -em" v-if="pendingAssignmentsCount==1">
							<q-icon class="c-inbox-header__warning" name="o_warning"/>
							Vous avez {{ pendingAssignmentsCount }} affectation en attente
						</div>
						<div class="-title -em" v-if="pendingAssignmentsCount>1">
							<q-icon class="c-inbox-header__warning" name="o_warning"/>
							Vous avez {{ pendingAssignmentsCount }} affectations en attente
						</div>
					</div>
					<div class="o-col -right -middle">
						<router-link
							class="o-button -lg"
							:to="{ name: 'pendings'}"
							@click="initialTab='pendings';"
						>
							Consulter
						</router-link>
					</div>
				</div>
			</div>
		</div>

		<div class="c-inbox-content">
			<div class="c-inbox-nav -hidden-mobile">
				<router-link class="-item" :to="{ name: 'inbox'}"
					:class="{
						'is-selected' : initialTab=='inbox',
					}"
					@click="initialTab='inbox'"
				>
					<span class="-ico__wrap">
						<SvgIcon name="inbox" />
						<q-badge class="-badge" rounded align="middle" :label="unreadMessagesCount"></q-badge>
					</span>
					<span class="-label">Boîte de<br>réception</span>
				</router-link>
				<!-- <router-link class="-item -pending-tab" :to="{ name: 'pending'}"
					:class="{
						'is-selected' : initialTab=='pending',
					}"
					@click="initialTab='pending'"
					v-if="myUserProfile.role=='ADMINISTRATOR' || myUserProfile.role=='MANAGER'"
				>
					<span class="-ico__wrap">
						<SvgIcon name="pending" />
					<q-badge class="-badge" rounded align="middle" :label="pendingAssignmentsCount"></q-badge>
					</span>
					<span class="-label">Affectations<br>en attente</span>
				</router-link> -->
				<router-link class="-item -pending-tab" :to="{ name: 'pendings'}"
					:class="{
						'is-selected' : initialTab=='pendings',
					}"
					@click="initialTab='pendings'"
				>
					<span class="-ico__wrap">
						<SvgIcon name="pending" />
					<q-badge class="-badge" rounded align="middle" :label="pendingAssignmentsCount"></q-badge>
					</span>
					<span class="-label">Affectations<br>en attente</span>
				</router-link>
			</div>

			<router-view
				:userProfile="userProfile"
				:isMobile="isMobile"
				@change-inbox="$emit('change-inbox', $event)"
			></router-view>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Messages',
		//components: { Component1, Component2 },
		props: {
            isMobile: {
                type: Boolean,
                default: false
            },
			inboxUserProfile: {
				type: Object,
				default: null,
			}
		},
		data(){
			return {
                myUserProfileID: window.myUserProfileID,
                myUserProfile: window.myUserProfile,
				userProfile: window.myUserProfile,
				pendingAssignmentsCount: 0,
				unreadMessagesCount: 0,
			}
		},
		mounted(){
			// this.$emit('change-inbox', this.myUserProfile)
			if(this.inboxUserProfile) this.userProfile=this.inboxUserProfile
			this.unreadMessagesCount=window.unreadMessagesCount
            this.pendingAssignmentsCount=window.pendingAssignmentsCount
            this.$eventBus.$on('set-notifs-count', function(e){
                this.pendingAssignmentsCount=e.pendingAssignmentsCount;
                this.unreadMessagesCount=e.unreadMessagesCount;
            }.bind(this))
			this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )

		},
        beforeDestroy() {
            // this.$eventBus.$off('set-notifs-count');
        },
		watch: {
			inboxUserProfile: function(){
				this.userProfile=this.inboxUserProfile
			},
			initialTab: function(){
				this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )
				if(this.initialTab=="pending") this.userProfile=this.myUserProfile;
			}
		},
		computed: {
			initialTab: function () {
				if(this.$route.name == 'pending') return 'pendings'
				return this.$route.name;
			},
		},
		//watch: {},
		//methods: {},
	}
</script>

<style lang="scss">
	@import "@/scss/views/Dashboard.scss";
    @import "@/scss/components/dashboard/Inbox.scss";
</style>
